module.exports = __webpack_public_path__ + "static/media/todo.67a48d87.svg";